import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm3EditPopupViewVersionLiveInputFieldName =
  'version'|'version_kana'|'version_en'|
  'city'|'city_kana'|'city_en'|
  'place'|'place_kana'|'place_en'|
  'year'|'year_kana'|'year_en';

/**
 * バージョン入力（ライブ）
 */
export default function MusicAlbumEditForm3EditPopupViewVersionLiveInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: MusicAlbumEditForm3EditPopupViewVersionLiveInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewVersionLiveInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewVersionLiveInputFieldName) => FieldValidationErrorsType,
}) {
  return (
    <>
      <span className="ttl_parent">ライブ会場名</span>
      <div className="parent_body">
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">会場</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="​有明アリーナ"
              value={getValue('place')}
              setValue={(value) => setValue('place', value)}
              validationErrors={getErrors('version')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">ひらがな​</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="ありあけありーな"
              value={getValue('place_kana')}
              setValue={(value) => setValue('place_kana', value)}
              validationErrors={getErrors('version_kana')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">英語</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="Ariake Arena"
              value={getValue('place_en')}
              setValue={(value) => setValue('place_en', value)}
              validationErrors={getErrors('version_en')}
            />
          </dd>
        </dl>
      </div>
      <div className="parent_body">
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">都市名</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="​東京"
              value={getValue('city')}
              setValue={(value) => setValue('city', value)}
              validationErrors={getErrors('version')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">ひらがな​</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="とうきょう"
              value={getValue('city_kana')}
              setValue={(value) => setValue('city_kana', value)}
              validationErrors={getErrors('version_kana')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">英語</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="Tokyo"
              value={getValue('city_en')}
              setValue={(value) => setValue('city_en', value)}
              validationErrors={getErrors('version_en')}
            />
          </dd>
        </dl>
      </div>
      <div className="parent_body">
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">年</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="​2021"
              value={getValue('year')}
              setValue={(value) => setValue('year', value)}
              validationErrors={getErrors('version')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">ひらがな​</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="にせんにじゅういち"
              value={getValue('year_kana')}
              setValue={(value) => setValue('year_kana', value)}
              validationErrors={getErrors('version_kana')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="/">英語</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="2021"
              value={getValue('year_en')}
              setValue={(value) => setValue('year_en', value)}
              validationErrors={getErrors('version_en')}
            />
          </dd>
        </dl>
      </div>
    </>
  );
}
